import { ChakraProvider, LocaleProvider } from '@chakra-ui/react';
import { system } from '@/theme';
import { IconoirProvider } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';

/**
 * Chakra defaults its formatting locale to en-US, which made every `Money` /
 * `FormatNumber` render Anglo-Saxon (`€216.00`) even for a French user who
 * expects `216,00 €`. Binding the locale to the active i18n language fixes the
 * whole app at once, and follows a language switch because `useTranslation`
 * re-renders on it. Falls back to i18n's own `fallbackLng` before init settles,
 * and stays optional-chained so a test double that only stubs `t` cannot crash
 * the whole provider tree.
 */
export function Provider(props: ColorModeProviderProps) {
  const { i18n } = useTranslation();

  return (
    <ChakraProvider value={system}>
      <LocaleProvider locale={i18n?.language || 'en'}>
        <IconoirProvider iconProps={{ strokeWidth: 1.9 }}>
          <ColorModeProvider {...props} />
        </IconoirProvider>
      </LocaleProvider>
    </ChakraProvider>
  );
}
